import React from 'react';
import { RoutePermittedRole } from '@crema/constants/AppEnums';

const DesignTemplateRegister = React.lazy(() => import('../../modules/DesignTemplateManagement/DesignTemplateRegister'));
const DesignTemplateDetail = React.lazy(() => import('../../modules/DesignTemplateManagement/DesignTemplateDetail'));
const ChannelProductList = React.lazy(() => import('../../modules/DesignTemplateManagement/ChannelProductList'));
const DesignTemplateSale = React.lazy(() => import('../../modules/DesignTemplateManagement/DesignTemplateSale'));
const DesignResources = React.lazy(() => import('../../modules/DesignTemplateManagement/DesignResources'));
const MineDesignResourceDetail = React.lazy(() => import('../../modules/designManagement/DesignResource/MineDesignResourceDetail'));
const MyPodProductRegister = React.lazy(() => import('../../modules/DesignTemplateManagement/MyPodProductRegister'));
const Editor = React.lazy(() => import('../../modules/editor'));
const MyPodProductList = React.lazy(() => import('../../modules/DesignTemplateManagement/MyPodProductList'));

export const designTemplateManagementConfigs = [
  {
    permittedRole: RoutePermittedRole.User,
    path: '/buildDesignTemplate',
    element: <DesignTemplateRegister />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/buildDesignTemplate/detail',
    element: <DesignTemplateDetail />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/buildDesignTemplate/products',
    element: <ChannelProductList />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/sellDesignTemplate',
    element: <DesignTemplateSale />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/designResources',
    element: <DesignResources />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/designResources/detail',
    element: <MineDesignResourceDetail />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/myPod',
    children: [
      {
        path: 'new',
        element: <MyPodProductRegister />,
      },
      {
        path: 'editing',
        element: <MyPodProductList key={'editing'} status={'editing'} />,
      },
      {
        path: 'waiting',
        element: <MyPodProductList key={'waiting'} status={'waiting'} />,
      },
      {
        path: 'forSale',
        element: <MyPodProductList key={'forSale'} status={'forSale'} />,
      },
    ],
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: ['/editor', '/editor-open'],
    element: <Editor />,
  },
  // {
  //   permittedRole: RoutePermittedRole.User,
  //   path: '',
  //   element: <Editor />,
  // },
];
